import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static targets = ['list'];
  static values = {
    inputSelector: String,
    childrenSelector: String,
    fetchUrl: String,
    objectName: String,
    handleSelector: String
  };

  connect() {
    const scope = this;
    this.sortable = Sortable.create(this.listTarget, {
      onSort: () => scope.onSort(scope),
      handle: (this.handleSelectorValue || false)
    });
  };

  onSort(scope) {
    const selector = scope.inputSelectorValue;
    const allItems = scope.listTarget.querySelectorAll(scope.childrenSelectorValue);

    const data = {};
    for (let i = 0; i < allItems.length; i++) {
      const item = allItems[i];
      data[item.querySelector(this.inputSelectorValue).dataset.objectId] = i;
      item.querySelector(selector).value = i;
    };

    fetch(scope.fetchUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ [scope.objectNameValue]: data }),
    });
  };
};